var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "page-container-for-demo"
  }, [_c('el-dialog', {
    attrs: {
      "title": "请选择",
      "visible": _vm.dialogVisible,
      "width": "600px",
      "custom-class": "sku-dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "product-header"
  }, [_c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgFirst,
      "alt": "Product Image"
    }
  })]), _c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "price-info"
  }, [_c('span', {
    staticClass: "current-price"
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("¥")]), _vm.productInfo.realDiscountStatus ? _c('span', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.productInfo.realDiscountPrice))]) : _c('span', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.productInfo.price))])]), _vm.productInfo.realDiscountStatus ? _c('span', {
    staticClass: "price-label"
  }, [_vm._v("到手价")]) : _vm._e(), _vm.productInfo.realDiscountStatus ? _c('span', {
    staticClass: "original-price"
  }, [_vm._v("优惠前 ¥" + _vm._s(_vm.productInfo.price))]) : _vm._e()]), _c('div', {
    staticClass: "selected-sku-info"
  }, [_vm._v(" 已选: " + _vm._s(_vm.selectedSku.natureValue || '请选择版本') + " ")]), _c('div', {
    staticClass: "quantity-selector"
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 99,
      "size": "mini"
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  })], 1)])]), _c('div', {
    staticClass: "sku-selection-area"
  }, [_c('div', {
    staticClass: "sku-group"
  }, [_c('div', {
    staticClass: "sku-group-title"
  }, [_vm._v("版本")]), _c('div', {
    staticClass: "sku-tags"
  }, _vm._l(_vm.objData.selectarr, function (sku) {
    return _c('el-tag', {
      key: sku.id,
      staticClass: "sku-tag",
      attrs: {
        "type": _vm.selectedSku.id === sku.id ? '' : 'info',
        "effect": _vm.selectedSku.id === sku.id ? 'dark' : 'plain'
      },
      on: {
        "click": function click($event) {
          return _vm.selectSku(sku);
        }
      }
    }, [_vm._v(" " + _vm._s(sku.natureValue) + " ")]);
  }), 1)])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.handClick
    }
  }, [_vm._v(" 加入购物车 ")])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };